import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, FileCheck, AlertCircle, LogOut, Menu, X, ShieldAlert } from 'lucide-react';
import { Button } from '../ui/Button';
interface AdminLayoutProps {
  children: React.ReactNode;
}
export function AdminLayout({
  children
}: AdminLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'داشبورد مدیریت',
    href: '/admin',
    icon: LayoutDashboard
  }, {
    name: 'مدیریت کاربران',
    href: '/admin/users',
    icon: Users
  }, {
    name: 'بیمه‌نامه‌ها',
    href: '/admin/policies',
    icon: FileCheck
  }, {
    name: 'صف خسارت‌ها',
    href: '/admin/claims',
    icon: AlertCircle
  }];
  const isActive = (path: string) => location.pathname === path;
  return <div className="min-h-screen bg-gray-100 flex" data-id="element-36">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-37" />}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 right-0 z-50 w-64 bg-slate-900 text-white transform transition-transform duration-200 ease-in-out
        ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
      `} data-id="element-38">
        <div className="h-16 flex items-center justify-between px-6 border-b border-slate-800" data-id="element-39">
          <div className="flex items-center gap-2 font-bold text-xl" data-id="element-40">
            <ShieldAlert className="h-6 w-6 text-blue-400" data-id="element-41" />
            <span data-id="element-42">پنل مدیریت</span>
          </div>
          <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden text-slate-400" data-id="element-43">
            <X className="h-6 w-6" data-id="element-44" />
          </button>
        </div>

        <nav className="p-4 space-y-1" data-id="element-45">
          {navigation.map(item => <Link key={item.href} to={item.href} className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive(item.href) ? 'bg-blue-600 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`} data-id="element-46">
              <item.icon className="h-5 w-5" data-id="element-47" />
              {item.name}
            </Link>)}
        </nav>

        <div className="absolute bottom-0 w-full p-4 border-t border-slate-800" data-id="element-48">
          <Link to="/" data-id="element-49">
            <Button variant="ghost" className="w-full justify-start text-slate-400 hover:text-white hover:bg-slate-800" data-id="element-50">
              <LogOut className="h-5 w-5 ml-2" data-id="element-51" />
              خروج
            </Button>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-52">
        {/* Header */}
        <header className="h-16 bg-white border-b flex items-center justify-between px-4 lg:px-8 shadow-sm" data-id="element-53">
          <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-md" data-id="element-54">
            <Menu className="h-6 w-6" data-id="element-55" />
          </button>

          <div className="flex items-center gap-4 mr-auto" data-id="element-56">
            <div className="flex items-center gap-3" data-id="element-57">
              <div className="h-8 w-8 rounded-full bg-slate-900 flex items-center justify-center text-white font-bold" data-id="element-58">
                A
              </div>
              <span className="text-sm font-medium hidden sm:block" data-id="element-59">
                ادمین سیستم
              </span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4 lg:p-8 overflow-auto" data-id="element-60">
          <div className="max-w-7xl mx-auto" data-id="element-61">{children}</div>
        </main>
      </div>
    </div>;
}